import fetchService from 'common/actions/fetchService';

export default ({
  pnrCode,
  tripItineraryId,
  paymentMethod,
}) => async dispatch => {
  return dispatch(
    fetchService(({ pssService }) =>
      pssService.fetch('POST', '/api/v2/busextranetagent/booking/issue', {
        pnrCode,
        tripItineraryId,
        paymentMethod,
      })
    )
  );
};
